
import Vue from 'vue';
import { benefits, extraBenefits } from '../constants';
import BravadoCard from '~/components/partials/landings/ui/BravadoItemCard.vue';

export default Vue.extend({
  name: 'CareersBenefits',
  components: { BravadoCard },
  data() {
    return {
      benefits,
      extraBenefits,
    };
  },
});
